import { render } from "./LaneWise.vue?vue&type=template&id=edf657ae"
import script from "./LaneWise.vue?vue&type=script&lang=js"
export * from "./LaneWise.vue?vue&type=script&lang=js"

import exportComponent from "/home/azai-web/azaitech-website-template-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__